module.exports = __webpack_public_path__ + "static/media/ICON_QUICK_START_SIMPLE.3f58c568.png";